import { IonContent, IonPage, IonRow } from '@ionic/react';

import Cart from '../../components/cart/Cart';
import LayoutGap from '../../layouts/LayoutGap';
import Toolbar from '../../layouts/Toolbar';
import Events from './Tour/Events';

interface Props {
  events: []
}

const Tab3: React.FC<Props> = (props) => {
  return <IonPage className="tab-content">
    <Toolbar title="سفرها"></Toolbar>

    <LayoutGap />

    <IonContent class="main-content">
      <IonRow>
        <Events items={props.events} />
      </IonRow>
    </IonContent>
  </IonPage>
}

export default Tab3;
